export enum RaceTypes {
  Races,
  Trots,
  Dogs,
}
